"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dcAPI_1 = __importDefault(require("../api/dcAPI"));
const useLikePoi = (user) => {
    const setLikePoi = async (v_rid, like) => {
        if (user.token === "") {
            // if (window.confirm("로그인이 필요한 기능입니다. 로그인 하시겠습니까?")) {
            //   window.location.href = window.location.href = "/user/?mode=login";
            // }
            return -1;
        }
        const params = {
            mode: "restaurant",
            token: user.token,
            v_rid,
            favorites: like ? "Y" : "N",
        };
        try {
            const { data: { result_data: { count }, }, } = await dcAPI_1.default.favoritesRestaurant(params);
            return count;
        }
        catch (e) { }
        return -1;
    };
    return setLikePoi;
};
exports.default = useLikePoi;
